import { ajax } from '../ajax'

//1、 授课-获取教学课程列表
export const reqSKCourseList = (paramets) => ajax(`/homepage/teachingHomepage/getTeachCourseList`, paramets )
//2、 授课-是否打开手写板
export const reqOpenPad = (paramets) => ajax(`/wacom/basicWacomClassroom/isOpenPad`, paramets )
//3、 授课-获取评分类型
export const reqEvaluateType = (paramets) => ajax(`/classroom/basicClassroomScore/getScoreListByTeaType`, paramets )
//4、 授课-添加教室
export const reqAddClassroom = (paramets) => ajax(`/jxclassroom/jxClassroom/add`, paramets, 'post' )